/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampaignsResponseApiModel } from '../../models/campaigns-response-api-model';

export interface List$Params {

/**
 * response size
 */
  limit?: number;

/**
 * current page
 */
  page?: number;
}

export function list(http: HttpClient, rootUrl: string, params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<CampaignsResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, list.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampaignsResponseApiModel>;
    })
  );
}

list.PATH = '/campaigns';
